import Link from 'next/link';
import IconArrowRightLarge from '@picsart/icons/IconArrowRightLarge';
import { Button, ButtonSizeLG, ButtonVariants, ButtonSkinPrimary } from '@picsart/button';
import { useTranslation } from 'react-i18next';

import analytics from '../../../services/analytics';

import useStyles from './styles';

export default function OpenAiWriterButton() {
  const classes = useStyles();
  const { t } = useTranslation();
  const onClick = () => {
    analytics.pageClick({
      category_name: 'ai_writer',
      action_type: 'open_ai_writer',
      page_path: window.location.pathname,
    });
  };

  return (
    <Link href="/text/ai-writer/create/" passHref>
      <a>
        <Button
          size={ButtonSizeLG}
          variant={ButtonVariants.Filled}
          skin={ButtonSkinPrimary}
          endIcon={IconArrowRightLarge}
          className={classes.openBtn}
          onClick={onClick}
        >
          <span>{t('generalLanding.genExample.btnOpen')}</span>
          <span className={classes.secondPartBtn}>{t('generalLanding.genExample.btnOpen2')}</span>
        </Button>
      </a>
    </Link>
  );
}
